import { render, staticRenderFns } from "./travelSpecsLog.vue?vue&type=template&id=3a6d4622&scoped=true&"
import script from "./travelSpecsLog.vue?vue&type=script&lang=js&"
export * from "./travelSpecsLog.vue?vue&type=script&lang=js&"
import style0 from "./travelSpecsLog.vue?vue&type=style&index=0&id=3a6d4622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d4622",
  null
  
)

export default component.exports